export const COMPANY_CREATED = "company.created" as const;
export const CONTACT_CREATED = "contact.created" as const;
export const CONTACT_NOTE_CREATED = "contactNote.created" as const;
export const PROJECT_CREATED = "project.created" as const;
export const PROJECT_NOTE_CREATED = "projectNote.created" as const;
// Deprecated names are retained so existing activity consumers keep working.
export const DEAL_CREATED = PROJECT_CREATED;
export const DEAL_NOTE_CREATED = PROJECT_NOTE_CREATED;
